export interface OntologyApplicableAssetSet {
    Type: number;
    KnowledgeBookID?: string | null;
    ApplicableOntologyIDs?: string[] | null;
    AssetTagIDs?: unknown[] | null;
    HierarchyItems?: unknown[] | null;
}

const ALL_3D_ASSETS_TYPE = 2;
const ALL_ASSET_TAGS_TYPE = 4;

const isSpecialType = (type: number) =>
    type === ALL_3D_ASSETS_TYPE || type === ALL_ASSET_TAGS_TYPE;

interface ApplicableFacilityAssetSetOptions {
    includeEmpty?: boolean;
}

export const getApplicableFacilityAssetSets = <T extends OntologyApplicableAssetSet>(
    assetSets: readonly T[],
    selectedOntologyID?: string | null,
    options?: ApplicableFacilityAssetSetOptions
): T[] => {
    if (!selectedOntologyID) return [];

    const normalizedOntologyID = selectedOntologyID.toLocaleLowerCase();
    return assetSets.filter(assetSet =>
        !assetSet.KnowledgeBookID
        && !isSpecialType(assetSet.Type)
        && (
            (assetSet.ApplicableOntologyIDs ?? []).some(id =>
                id.toLocaleLowerCase() === normalizedOntologyID)
            || (options?.includeEmpty
                && (assetSet.AssetTagIDs?.length ?? 0) === 0
                && (assetSet.HierarchyItems?.length ?? 0) === 0)
        ));
};

export const getManageableFacilityAssetSets = <T extends OntologyApplicableAssetSet>(
    assetSets: readonly T[]
): T[] => assetSets.filter(assetSet =>
    !assetSet.KnowledgeBookID && !isSpecialType(assetSet.Type));
